import React, { useContext, useEffect, useState } from 'react'
import firebase from 'firebase'
import { UserContext } from '../../App'
function AddLink() {
    const [linkName, setLinkName] = useState('')
    const [link, setLink] = useState('')
    const [id, setId] = useState('')
    const [obj, setObj] = useState([])
    const user = useContext(UserContext)
    useEffect(() => {
        let linkId = '';
        let isSubscribed = true;
        firebase.database().ref('users').child(user.uid).child('linkid').get()
            .then(s => {
                if (isSubscribed) {
                    linkId = s.val()
                    setId(linkId)
                }
            })

        return () => { isSubscribed = false }
    }, [])
    useEffect(
        () => {
            let isSubscribed = true;
            if (id !== '') {
                let linkId = id;
                try {
                    firebase.database().ref(linkId).child('links').get().then(
                        s => {
                            if (s.exists()) {
                                if (isSubscribed) {
                                    setObj(Object.keys(s.val()))
                                    console.log("s.val", s.val())
                                }
                            }
                        }
                    )
                }
                catch (e) {
                    console.log(e)
                }
            }
            return () => { isSubscribed = false }

        }, [id]
    )


    const Submit = e => {
        e.preventDefault()
        if (id !== '') {
            let encryted_link_url;
            let i = 0;
            for (let char in link) {
                encryted_link_url = encryted_link_url + link.charCodeAt(i + 10);
                i = i + 1;
            }
            firebase.database().ref(id).child('links').child(linkName).set(link).then(() => window.location.reload())
        }

    }

    return (
        <div>
            <button type="button" className="btn btn-secondary text-primary" data-toggle="modal" data-target="#exampleModal">
                Add Link
            </button>
            <div className="modal fade text-primary" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header bg-secondary">
                            <h5 className="modal-title ">Create Link</h5>
                            <button type="button" className="close text-primary" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body  bg-secondary">
                            <form>
                                <div className="form-group bg-secondary">
                                    <label >Link Name</label>
                                    <input className='text-dark' onChange={(e) => setLinkName(e.target.value)} value={linkName} type="text" className="form-control" />
                                    {!(obj.includes(linkName)) ?
                                        <small className="form-text text-primary ">Keep it unique</small>
                                        :
                                        <small className="form-text text-danger">Link with this name already exists</small>
                                    }
                                </div>
                                <div className="form-group">
                                    <label >Link</label>
                                    <input onChange={(e) => setLink(e.target.value)} value={link} type="text" className="form-control" />
                                </div>

                                {!(obj.includes(linkName)) ?
                                    <button type="submit" data-toggle="modal" data-target="#exampleModal"
                                        onClick={e => Submit(e)} className="btn text-primary btn-dark mt-3 mb-4">Submit</button>
                                    :
                                    <button onClick={e => e.preventDefault()} className="btn btn-primary mt-3 mb-4 disabled">Submit</button>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddLink
